import { async } from "q";
import axiosClient from "./axiosClient";

const serviceURL = "/qlkhambenh";
const servicePackage = {
  getListServicePackage: async (params) => {
    const url = serviceURL + `/list-dm-goi-dich-vu`;
    const response = await axiosClient.get(url, {
      params: params,
    });
    return response.data;
  },
  postServicePackage: async (params) => {
    const url = serviceURL + `/dm-goi-dich-vu`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  putServicePackage: async (params) => {
    const url = serviceURL + `/dm-goi-dich-vu?id=${params.id}`;
    const response = await axiosClient.put(url, params);
    return response.data;
  },
  postAddService2Package: async (params) => {
    const url = serviceURL + `/dm-goi-dich-vu/dich-vu-ky-thuat`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  postMedical2Package: async (params) => {
    const url = serviceURL + `/dm-goi-dich-vu/thuoc`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  postVTYT2Package: async (params) => {
    const url = serviceURL + `/dm-goi-dich-vu/vtyt`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  postOther2Package: async (params) => {
    const url = serviceURL + `/dm-goi-dich-vu/khac`;
    const response = await axiosClient.post(url, params);
    return response.data;
  },
  deleteElement: async (params) => {
    const url = serviceURL + `/dm-goi-dich-vu/xoa-thanh-phan`;
    const response = await axiosClient.delete(url, { params: params });
    return response.data;
  },
  getServicePackage: async (params) => {
    const url = serviceURL + `/dm-goi-dich-vu`;
    const response = await axiosClient.get(url, { params: params });
    return response.data;
  },

  //xoá gói
  deletePageket: async (id) => {
    const url = serviceURL + `/dm-goi-dich-vu?id=${id}`;
    const response = await axiosClient.delete(url);
    return response.data;
  },
};

export default servicePackage;
